import PropTypes from 'prop-types';
import React from 'react';

export default class extends React.Component {
    static propTypes = {
        onSubmit: PropTypes.func,
        autocomplete: PropTypes.string
    };

    static defaultProps = {
        autocomplete: 'on'
    };

    render() {
        const { autocomplete, children } = this.props;
        return (
            <form onSubmit={this._onSubmit} autoComplete={autocomplete}>
                {children}
            </form>
        );
    }

    _onSubmit = (e) => {
        if (this.props.onSubmit) {
            this.props.onSubmit();
        }
        e.preventDefault();
    };
}
